/**
 * Tenant API error handling: friendly errors and session-expired flow.
 * - SESSION_EXPIRED: dispatch event so auth context can toast + sign out
 * - FETCH_FAILED / FORBIDDEN: show "Something went wrong" in UI, no verbose messages
 */

export const TENANT_SESSION_EXPIRED_EVENT = 'tenant-session-expired';

export type TenantApiErrorCode = 'SESSION_EXPIRED' | 'FORBIDDEN' | 'FETCH_FAILED';

export class TenantApiError extends Error {
  code: TenantApiErrorCode;
  userMessage: string;

  constructor(code: TenantApiErrorCode, userMessage: string) {
    super(userMessage);
    this.name = 'TenantApiError';
    this.code = code;
    this.userMessage = userMessage;
  }
}

export function isTenantApiError(e: unknown): e is TenantApiError {
  return e instanceof TenantApiError;
}

export function dispatchSessionExpired(): void {
  window.dispatchEvent(new CustomEvent(TENANT_SESSION_EXPIRED_EVENT));
}

export const MESSAGES = {
  SESSION_EXPIRED: 'Your session has expired. Please sign in again.',
  FORBIDDEN: "You don't have access to this.",
  FETCH_FAILED: "We couldn't load the data. Please try again or sign out.",
} as const;
